//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data(){
        return{
            niceLogo0:require("../../../assets/detail/like_nor.png"),
            niceLogo1:require("../../../assets/detail/like_sel.png")
        }
    },

     methods: {
       changeState(){
            this.niceLogo0 = this.niceLogo1;
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/sns/bbs/detail.vue